import { objToFormData } from '@app/utils/utils';
import api from './../api';

export interface Contrato {
  id: string;
  numero: number;
  status: string;
  statusCodigo: number;
  dataHoraPrimeiraAtivacao?: Date;
  situacao: boolean;
  fornecedor: string;
  objetoResumido: string;
  possuiDocumentacaoAcessoria: boolean;
  possuiSegurosGarantias: boolean;
  possuiDocumentoSeguroGarantiaCadastrado: boolean;
  possuiDocumentacaoAcessoriaMensalCadastrada: boolean;
  seraAditado: boolean;
  statusEncerramentoCodigo: number;
  situacaoVencimento: string;
  isDefined?: boolean;
  isMultiplosGestores?: boolean;
  isConsolidado?: boolean;
}

export interface AbaPQEscopoMultiplosGestores{
  identificador: number;
  escopo: string;
  idPq: string;
  isResponsavel: boolean;
}

export interface updateAssociarPQ{
  identificador: number | undefined;
  escopo: string;
  contratoId: string;
  isMultiplosGestores: boolean;
  file?: File;
}
export const getAllContratos = () => api.get<Contrato[]>('contratos');
export const createContrato = (contrato: Contrato) => {
  return api.post<Contrato>('contratos', contrato);
};
export const updateContrato = (contrato: Contrato) => api.put(`contratos/${contrato.id}`, contrato);
export const deleteContrato = (id: string) => api.delete(`contratos/${id}`);
export const deletePqMultiplosGestores = (idContrato: string, idPq: string) => api.post(`contratos/deletePqMultiplosGestores`,{contratoId: idContrato, planilhaDeQuantidadeId: idPq});
export const deleteAllPqMultiplosGestores = (idContrato: string) => api.delete (`contratos/DeleteAllPqMultiplosGestores/${idContrato}`);

export const updateAssociarPlanilhaQuantidade = (formData: updateAssociarPQ) => {
    var form = objToFormData(formData);
    return api.post(`contratos/updateAssociarAtualizarPlanilhaQuantidade`, form, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
};

export const setMultiplosGestoresContrato = (id: string, isMultiplosGestores: boolean) => api.put(`contratos/updateMultiplosGestores/${id}`, {isMultiplosGestores: isMultiplosGestores});

export const consolidarPqsMultiplosGestores = (id: string) => api.put<any>(`contratos/consolidarPqsMultiplosGestores/${id}`);